import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/ondemand/components/Alert/index.js